import React from 'react'
import { Input, Select, Button, Space, DatePicker } from 'antd'
import { SearchOutlined, ClearOutlined, FilterOutlined } from '@ant-design/icons'

const { Search } = Input

interface ContentFilterBarProps {
    onSearch: (value: string) => void
    onCategoryChange: (category: string | undefined) => void
    onClear: () => void
    searchValue: string
    categoryValue: string | undefined
    categories: string[]
    placeholder?: string
}

export const ContentFilterBar: React.FC<ContentFilterBarProps> = ({
    onSearch,
    onCategoryChange,
    onClear,
    searchValue,
    categoryValue,
    categories,
    placeholder = 'Search by title...',
}) => {
    const categoryOptions = [
        { value: undefined, label: 'All Categories' },
        ...categories.map((cat) => ({ value: cat, label: cat })),
    ]

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
                padding: '16px',
                background: '#fafafa',
                borderRadius: '8px',
                marginBottom: '16px',
                alignItems: 'center',
            }}
        >
            <Search
                placeholder={placeholder}
                allowClear
                value={searchValue}
                onChange={(e) => onSearch(e.target.value)}
                onSearch={onSearch}
                style={{ width: 280 }}
                prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
            />

            <Select
                placeholder="Filter by category"
                allowClear
                value={categoryValue}
                onChange={onCategoryChange}
                style={{ width: 180 }}
                options={categoryOptions}
                suffixIcon={<FilterOutlined />}
            />

            <Button icon={<ClearOutlined />} onClick={onClear}>
                Clear Filters
            </Button>

            <div style={{ marginLeft: 'auto' }}>
                <Space>
                    {searchValue && (
                        <span style={{ color: '#666', fontSize: '13px' }}>
                            Searching: "{searchValue}"
                        </span>
                    )}
                    {categoryValue && (
                        <span style={{ color: '#666', fontSize: '13px' }}>
                            Category: {categoryValue}
                        </span>
                    )}
                </Space>
            </div>
        </div>
    )
}
